// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2x45a","content":"styles_content__2C6zY"};